module.exports = __webpack_public_path__ + "img/us_stock.54146770.png";